export default __webpack_public_path__ + "static/patio-v4-scheda-tecnica-71b268f744d32c5a9d7c19df9bde41e8.pdf";